import React, { useState } from "react";
import { useHistory } from "react-router";
import Tabs from "component/common/Tabs";
import SearchInput from "component/common/SearchInput";
import AddButton from "component/common/AddButton";
import AddInfluencer from "../AddInfluencer";
import { debounce } from "debounce";
import queryString from "query-string";

import styles from "./DirectoryLayout.module.scss";
import { getRoleAction } from "utils/helper";

const DirectoryLayout = ({ page, children, refresh }) => {
  const history = useHistory();

  const { isOperationAvailable } = getRoleAction("Directory");

  const tabs = [
    { label: "seller", to: "/admin/directory/seller" },
    { label: "buyer", to: "/admin/directory/buyer" },
    { label: "influencer", to: "/admin/directory/influencer" },
  ];

  let [isOpen, setIsOpen] = useState(false);

  const handleSearch = async (event) => {
    let params = queryString.stringify({
      search: event == "" ? undefined : event,
    });
    if (params == "") {
      history.push(`/admin/directory/${page}`);
    } else {
      history.push(`/admin/directory/${page}?${params}`);
    }
  };

  const toggle = () => {
    setIsOpen(!isOpen);
    refresh();
  };

  return (
    <>
      <div className="row d-flex align-items-center mb-2">
        <div className="col-md-6">
          <div className={styles.directory_header}>
            <div className={styles.title}>
              <b>Directory</b>
            </div>
            <Tabs page={page} tabs={tabs} />
          </div>
        </div>
        <div className="col-md-6">
          <div className={styles.directory_search}>
            {page === "influencer" && isOperationAvailable("Add") && (
              <AddButton label="ADD NEW" onClick={() => setIsOpen(true)} />
            )}
            <div className={styles.search}>
              <SearchInput
                placeholder="Search"
                onChange={debounce(handleSearch, 500)}
                onSearch={() => alert("search")}
              />
            </div>
          </div>
        </div>
      </div>
      <div>{children}</div>
      <AddInfluencer isOpen={isOpen} toggle={toggle} />
    </>
  );
};

export default DirectoryLayout;
